import store from "../../../../store";
import { OI_ALL_GRAPH, OI_CHANGE_GRAPH, OI_CHART_GRAPH, OPTION_CHAIN_GRAPH_ERROR, OPTION_CHAIN_GRAPH_EXPIRY_DATE_DATA, OPTION_CHAIN_GRPAH_HIDE_ERROR, OPTION_CHAIN_GRPAH_START_LOADER, OPTION_CHAIN_GRPAH_STOP_LOADER, OPTION_PAIN_GRAPH, } from "../interface/iOptionChainGraphs";
var OptionGraphChainActions = /** @class */ (function () {
    function OptionGraphChainActions() {
        this.dispatch = store.dispatch;
    }
    OptionGraphChainActions.prototype.updateGraphData = function (data) {
        this.dispatch({
            type: OI_ALL_GRAPH,
            payload: { data: data },
        });
    };
    OptionGraphChainActions.prototype.updateOIChangeGraphData = function (data) {
        this.dispatch({
            type: OI_CHANGE_GRAPH,
            payload: { data: data },
        });
    };
    OptionGraphChainActions.prototype.updateOIChartGraphData = function (data) {
        this.dispatch({
            type: OI_CHART_GRAPH,
            payload: { data: data },
        });
    };
    OptionGraphChainActions.prototype.updateOptionPainsGraphData = function (data) {
        this.dispatch({
            type: OPTION_PAIN_GRAPH,
            payload: { data: data },
        });
    };
    OptionGraphChainActions.prototype.updateExpiryDateData = function (expiryDateList) {
        this.dispatch({
            type: OPTION_CHAIN_GRAPH_EXPIRY_DATE_DATA,
            payload: { expiryDateList: expiryDateList },
        });
    };
    OptionGraphChainActions.prototype.setGrpahLoader = function (loaderType) {
        this.dispatch({
            type: OPTION_CHAIN_GRPAH_START_LOADER,
            loaderType: loaderType,
        });
    };
    OptionGraphChainActions.prototype.stopGraphLoader = function (loaderType) {
        this.dispatch({
            type: OPTION_CHAIN_GRPAH_STOP_LOADER,
            loaderType: loaderType,
        });
    };
    OptionGraphChainActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: OPTION_CHAIN_GRAPH_ERROR,
            payload: { errorData: payload },
            errorType: errorType,
        });
    };
    OptionGraphChainActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: OPTION_CHAIN_GRPAH_HIDE_ERROR,
            errorType: errorType,
        });
    };
    return OptionGraphChainActions;
}());
export default OptionGraphChainActions;
